import { render, staticRenderFns } from "./GenerateMatchesForOlympic.vue?vue&type=template&id=e8a3b4b8&scoped=true"
import script from "./GenerateMatchesForOlympic.vue?vue&type=script&lang=js"
export * from "./GenerateMatchesForOlympic.vue?vue&type=script&lang=js"
import style0 from "./GenerateMatchesForOlympic.vue?vue&type=style&index=0&id=e8a3b4b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a3b4b8",
  null
  
)

export default component.exports